import { render } from "./ticket-strikethrough.vue?vue&type=template&id=6d1d1b75"
import script from "./ticket-strikethrough.vue?vue&type=script&lang=js"
export * from "./ticket-strikethrough.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__